import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

function Spinner({ size = 24, className, style }) {
  return (
    <Icon
      name="fa-spinner-third"
      iconStyles={{ ...style, fontSize: size + 'px' }}
      iconClassName={`${className ? className + ' ' : ''}fa-spin`}
      duotone
    />
  );
}

Spinner.propTypes = {
  size: PropTypes.number,
};

export default Spinner;
